import { render } from "./MenuTooltip.vue?vue&type=template&id=292824fe"
import script from "./MenuTooltip.vue?vue&type=script&lang=js"
export * from "./MenuTooltip.vue?vue&type=script&lang=js"

import "./MenuTooltip.vue?vue&type=style&index=0&id=292824fe&lang=css"

import exportComponent from "/Users/trifjolngjela/Projects/home-budget/home-budget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu});
